import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { LabeledRow } from '../../../fulfillment-planner/labeled-row';
import { UserDateTimezoneFormat } from '../../../components/user-date-timezone-format';
import { isValidISOString } from '../../../services/time-helper-service';

import { messages } from '../../../fulfillment-planner/labeled-row/messages';
import style from './style.module.css';

const PickupDate = ({ pickupDate }) => {
  const normalizedPickupDate = isValidISOString(pickupDate) ? (
    <UserDateTimezoneFormat dateTime={pickupDate} showTime spaceBetweenTimeAndZone />
  ) : (
    pickupDate
  );
  return (
    <LabeledRow className={style.row} label={<FormattedMessage {...messages.localPickupTime} />} labelClassName={style.label}>
      {pickupDate ? <span className={style.info}>{normalizedPickupDate}</span> : <span className={style.mdash}>&mdash;</span>}
    </LabeledRow>
  );
};

PickupDate.propTypes = {
  pickupDate: PropTypes.string,
};

export default PickupDate;
